<script lang="ts">
import { getEnv } from '@monogrid/env'
import VersionInfo from '@monogrid/vue-boost/core/VersionInfo.vue'
import { defineComponent } from 'vue'

import SiteHeader from '@/components/organisms/SiteHeader.vue'

export default defineComponent({
  name: 'SiteLayout',
  components: {
    SiteHeader,
    VersionInfo
  },
  setup (props, { attrs, slots, emit }) {
    const env = getEnv()

    return {
      env
    }
  }
})
</script>

<template>
  <SiteHeader />
  <slot />
  <VersionInfo v-if="env.SERVICE_STAGE !== 'master'" id="version-info" />
</template>

<style lang="scss" scoped>
#version-info {
  top: 0;
  right: var(--scrollbar-placeholder) !important;
  bottom: auto !important;
}
</style>
